import { RouteComponentProps } from '@reach/router';
import { LessonPlan, LessonsApi } from 'api/lessonsApi';
import LessonPageStatus from 'components/lessons/LessonPageStatus';
import { LessonsRouteParams, useLessonsPage } from 'components/lessons/lessonsHelpers';
import Presentation from 'components/presentation/Presentation';
import SubjectSiteLayout from 'components/subjectSite/SubjectSiteLayout';
import React from 'react';

type Props = RouteComponentProps<LessonsRouteParams>;

const LessonPresentation: React.FC<Props> = (props) => {
  const result = useLessonsPage<LessonPlan>(props, (query, lessonNumber) =>
    LessonsApi.getPresentation(query, lessonNumber)
  );

  if (result === null || typeof result === 'string') {
    return <LessonPageStatus status={result} />;
  }
  if (result.details.presentationResources.length === 0) {
    return <LessonPageStatus status="notFound" />;
  }

  return (
    <SubjectSiteLayout colorCss={result.details.activity.colorCSS}>
      <Presentation slides={result.details.presentationResources} />
    </SubjectSiteLayout>
  );
};

export default LessonPresentation;
